import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import {
  DEFAULT_CANAL_OPTIONS,
  MODAL_TEXT_1_MONTH_TYPE,
  MODAL_TEXT_9_MONTHS_TYPE,
  MODAL_TEXT_COMMENT_TYPE,
  PAGINATION_CURRENT_PAGE,
  PAGINATION_START,
  SUB_TABS,
  SUB_TABS_COLUMNS
} from "./constants";
import { DatePicker, Input, Switch, Tag, Tooltip } from "antd";
import moment from "moment";
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import './index.scss';
import _ from './../../../i18n';
import lodash from 'lodash';
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getNewClients, getNewClientsCanals, saveNewClients, getAnnualCalendar, saveCollaboratorsPlanner, exportNewClients } from "../../../api";
import { toast } from "react-toastify";
import { AlertTriangleIcon, CheckIcon, ClipBoardIcon, IconClose, IconExport, IconPencil, LoadingIcon } from "../../common/Icons";
import { formatAmount, parsePreference } from "../../../utils";
import AnimatedLoadingIcon from "../../common/Icons/AnimatedLoadingIcon";
import { Link } from "react-router-dom";
import CroissanceFilters from "../Components/CroissanceFilters/CroissanceFilters";
import CreatableSelect from 'react-select/creatable';
import { CalendarWithTextIcon } from "../../common/Icons/CalendarWithTextIcon";
import { composeEventForOutlook } from "../../../utils/outlook";
import { useMsal } from "@azure/msal-react";
import { useIsAuthenticatedWithToken } from "../../../utils/hooks";
import { createEvent } from "../../../api/msal-graph";
import { loginRequest } from "../../../config/msal-config";


export default function CroissanceClientsInPage({
  changeSelectedYear,
  collaborator,
  preferences
}) {
  const { token, navCommunity, user } = useSelector((state) => state.auth);
  const { language } = useSelector((state) => state.params);
  const [selectedSubTab, setSelectedSubTab] = useState(SUB_TABS[0]);
  const [bindedSubTabsColumns, setBindedSubTabsColumns] = useState(SUB_TABS_COLUMNS);
  const [showTextModal, setShowTextModal] = useState(false);
  const [selectedTextType, setSelectedTextType] = useState(null);
  const [selectedRow, setSelectedRow] = useState({
    appelRdv1Month: false,
    appelRdv9Months: false,
  });
  const [annualCalendar, setAnnualCalendar] = useState(null);
  const [data, setData] = useState([]);
  const [canalsOptions, setCanalsOptions] = useState(DEFAULT_CANAL_OPTIONS);
  const [displayedData, setDisplayedData] = useState([]);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [modifiedRows, setModifiedRows] = useState([]);
  const modifiedRowsRef = useRef(modifiedRows);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [currentPage, setCurrentPage] = useState(PAGINATION_CURRENT_PAGE);
  const [pageStart, setPageStart] = useState(PAGINATION_START);
  const [isSaving, setIsSaving] = useState({
    comment: false,
    rowData: false
  });
  const [isExportingNewClients, setIsExportingNewClients] = useState(false);
  const [totalsData, setTotalsData] = useState([{
    'id': 0,
    'month': '-',
    'clientName': 'Total',
    'status': '--',
    'manager': '--',
    'lmProposition': 0,
    'isMandatesActivated': '--',
    'oneShot': 0,
    'billingType': '--',
    'selectedPlan': '--',
    'feeYearN': 0,
    'feeYearN1': 0,
    'rdv': '--',
    'isPresentationDone': '--',
    'appDemo': '--',
    'oneMonth': '--',
    'nineMonths': '--',
    'volumetry': '--',
  }]);

  const [filters, setFilters] = useState({
    keyWord: "",
    clientGroup: [],
    bu: parsePreference(preferences.financial).croissance.allowViewDataBy === 100 &&
      collaborator
        ? [collaborator.bu]
        : [],
    zone: parsePreference(preferences.financial).croissance.allowViewDataBy === 101 &&
      collaborator
        ? collaborator.zoneId
        : null,
    partner:
      parsePreference(preferences.financial).croissance.allowViewDataBy === 11
        ? user?.id
        : null,
    collaborator: [10, 100, 101, 110].includes(
      parsePreference(preferences.financial).croissance.allowViewDataBy
    ) && collaborator
      ? Number(collaborator.id)
      : null,
    role: null,
    pageSize: 50,
    year: new Date().getFullYear().toString(),
    reminderType: null,
  });

  const additionalFilters = [
    {
      type: "SELECT",
      options: {
        isSimple: true,
        isMulti: false,
        isClearable: true,
        isSearch: false,
        placeholder: _("Filtrer par rappel"),
        options: [
          { value: 'NONE', label: 'Sans rappel' },
          { value: 'ONE_MONTH', label: 'Rappel 1 mois' },
          { value: 'NINE_MONTHS', label: 'Rappel 9 mois' },
          { value: 'BOTH', label: 'Les deux rappels' },
        ],
        values: filters.reminderType,
        action: (value) => {
          setFilters({
            ...filters,
            reminderType: value
          });
        },
      },
    }
  ];
  const isAuthenticatedWithTokenToMsal = useIsAuthenticatedWithToken();
  const { instance, accounts } = useMsal();

  let getNewClientsQuery = useQuery(
    ["getNewClients", token, navCommunity, currentPage, pageStart, filters],
    async () => {
      const allowViewDataBy = parsePreference(
        preferences.financial
      ).croissance.allowViewDataBy;
      if (
        [10, 110].includes(allowViewDataBy) &&
        (!filters || !filters.collaborator)
      ) {
        setIsLoadingData(false);
        setData([]);
        setDisplayedData([]);
        setTotalDataCount(0);
        return [];
      } else if (token && navCommunity) {
        setIsLoadingData(true);
        try {
          const response = await getNewClients({
            token,
            organizationId: navCommunity.id,
            start: pageStart,
            filters
          });
          const data = response.data.data.items
          const totals = response.data.data.totals;

          setData(data);
          setDisplayedData(data);
          setTotalDataCount(response.data.data.totalCount);
          setTotalsData(prevState => {
            const newVal = {...prevState[0], ...totals};
            return [newVal];
          });
        } catch (e) {
          console.error("Error while fetching new clients", {e})
          return null;
        } finally {
          setIsLoadingData(false);
        }
      }
    }
  );

  let getNewClientsCanalsQuery = useQuery(
    ["getNewClientsCanals", token, navCommunity],
    async () => {
      const allowViewDataBy = parsePreference(
        preferences.financial
      ).croissance.allowViewDataBy;
      if (
        [10, 110].includes(allowViewDataBy) &&
        (!filters || !filters.collaborator)
      ) {
        return [];
      } else if (token && navCommunity) {
        try {
          const response = await getNewClientsCanals({
            token,
            organizationId: navCommunity.id
          });

          const data = response.data.data
          .filter(it => {
            // Filter out values that already exist in DEFAULT_CANAL_OPTIONS
            const existsInDefault = !DEFAULT_CANAL_OPTIONS.some(c =>
              c.value.toLowerCase() === it.toLowerCase()
            );

            // Filter out duplicate values from the current data
            const isDuplicate = canalsOptions.some(c =>
              c.value.toLowerCase() === it.toLowerCase()
            );

            return existsInDefault && !isDuplicate;
          })
          .map(it => ({
            value: it.trim(),
            label: it.trim()
          }));

          // Only update if we have new unique values
          if (data.length > 0) {
            setCanalsOptions(prevState => {
              // Create a new Set to ensure uniqueness
              const uniqueOptions = Array.from(
                new Set([...prevState, ...data].map(JSON.stringify)),
                JSON.parse
              );

              // Sort alphabetically by label
              return uniqueOptions.sort((a, b) =>
                a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
              );
            });
          }

        } catch (e) {
          console.error("Error while fetching canals", {e})
        }
      }
    }
  );

  let getAnnualCalendarQuery = useQuery(
    ["getAnnualCalendar", token, navCommunity, filters.year, filters.zone],
    async () => {
      if (token && navCommunity) {
        try {
          const response = await getAnnualCalendar({
            token,
            organizationId: navCommunity.id,
            year: filters.year,
            zone: filters.zone
          });
          setAnnualCalendar(response.data.data);
        } catch (e) {
          console.error("Error while fetching annual calendar", {e});
          setAnnualCalendar(null);
          return null;
        }
      }
    }
  );


  useEffect(() => {
    // TODO: add test to check if the current user is Maxime.
    if (user.id === 484492) { // Sync events with Maxime's Outlook calendar ONLY
      if (data && annualCalendar?.modifiers && isAuthenticatedWithTokenToMsal) {
        syncClientsMeetingsToPlannerAndOutlook().then(() => {
          console.log("Synced clients meetings to outlook");
        });
      }
    }
  }, [data, annualCalendar]);

  useEffect(() => {
    // bind body templates to columns
    const BINDED_SUB_TABS_COLUMNS = {};

    BINDED_SUB_TABS_COLUMNS.admin = SUB_TABS_COLUMNS.admin.map((col) => {
      if (col.field === 'month') {
        col.body = monthColumnBodyTemplate;
      } else if (col.field === 'clientName') {
        col.body = clientNameColumnBodyTemplate;
      } else if (col.field === 'status') {
        col.body = statusColumnBodyTemplate;
      } else  if (col.field === 'manager') {
        col.body = managerColumnBodyTemplate;
      } else if (col.field === 'billingType' || col.field === 'selectedPlan') {
        col.body = textColumnBodyTemplate;
      } else if (col.field === 'lmProposition') {
        col.body = checkUncheckColumnBodyTemplate;
      } else if (col.field === 'canal') {
        col.body = canalColumnBodyTemplate;
      }else if (col.field === 'isMandatesActivated') {
        col.body = switchColumnsBodyTemplate;
      } else if (col.field === 'oneShot' || col.field === 'feeYearN' || col.field === 'feeYearN1') {
        col.body = amountColumnBodyTemplate;
      } else if (col.field === 'createdAt' || col.field === 'creationDate') {
        col.body = dateColumnBodyTemplate;
      }
      return col;
    });

    BINDED_SUB_TABS_COLUMNS.actions = SUB_TABS_COLUMNS.actions.map((col) => {
      if (col.field === 'rdv') {
        col.body = rdvColumnBodyTemplate;
      } else if (col.field === 'isPresentationDone' || col.field === 'appDemo') {
        col.body = switchColumnsBodyTemplate;
      } else if (col.field === 'oneMonth' || col.field === 'nineMonths') {
        col.body = inputFieldColumnBodyTemplate
      } else if (col.field === 'volumetry') {
        col.body = volumetryProgressionColumnBodyTemplate;
      } else if (col.field === 'actions') {
        col.body = actionsColumnBodyTemplate;
      }
      return col;
    });
    setBindedSubTabsColumns(BINDED_SUB_TABS_COLUMNS);
  }, [selectedRow, canalsOptions]);

  useEffect(() => {
    modifiedRowsRef.current = modifiedRows;
  }, [modifiedRows]);

  const syncClientsMeetingsToPlannerAndOutlook = async () => {
    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    });

    for (let i = 0; i < data.length; i++) {
      if (data[i].id === 0) continue;

      const clientDeadline = data[i].deadline;

      if (!clientDeadline) continue;

      let oneMonthMeetingOutlookEventId = null;
      let nineMonthsMeetingOutlookEventId = null;

      // console.log(`Client ID = ${data[i].clientId} - Creation Date = ${data[i].creationDate} - 1 Month Date = ${moment(data[i].creationDate).add(1, 'month').format("YYYY-MM-DD")} - 9 Months Date = ${moment(data[i].creationDate).add(9, 'month').format("YYYY-MM-DD")}`);

      const holidays = [...annualCalendar.modifiers.holidays, ...annualCalendar.modifiers.annualHolidays];

      if (!data[i]?.oneMonthMeeting?.outlookEventId) {
        const oneMonthDate = moment(clientDeadline).add(1, 'month');

        // skip weekends and holidays
        let isValidDate = false;
        while (!isValidDate) {
          isValidDate = true;

          // check if it's weekend (0 = Sunday, 6 = Saturday)
          if (oneMonthDate.day() === 0 || oneMonthDate.day() === 6) {
            oneMonthDate.add(1, 'day');
            isValidDate = false;
            continue;
          }

          // check if it's a holiday
          if (annualCalendar?.modifiers) {
            if (holidays.some(holiday => moment(holiday).isSame(oneMonthDate, 'day'))) {
              oneMonthDate.add(1, 'day');
              isValidDate = false;
            }
          }
        }

        // TODO: remove this when 2026 annual calendar is configured.
        if (oneMonthDate.year() === 2026) {
          oneMonthMeetingOutlookEventId = null;
        } else {
          const eventTitle = "Rendez-vous de 1 mois avec " + data[i].clientName;
          const eventDetails = composeEventForOutlook({
            type: "newClientMeeting",
            title: eventTitle,
            date: oneMonthDate,
            timezone: "Europe/Brussels",
            clientName: data[i].clientName,
            selectedColor: 'green',
            attendees: []
          });

          const eventResponse = await createEvent(
            tokenResponse.accessToken,
            eventDetails
          );

          // save event to Maxime's planner
          saveCollaboratorsPlanner(
            null,
            navCommunity.id,
            'management',
            eventTitle,
            'remote',
            226, // Maxime's collaborator ID
            [String(226)],
            data[i].clientId,
            null,
            'A faire',
            oneMonthDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSS"),
            null,
            'green',
            null,
            null,
            60,
            0,
            null,
            oneMonthDate.year(),
            token,
            eventResponse.id,
            eventResponse?.onlineMeeting?.joinUrl || null,
            [],
            null
          );

          oneMonthMeetingOutlookEventId = eventResponse.id;
        }
      }

      if (!data[i]?.nineMonthsMeeting?.outlookEventId) {
        const nineMonthsDate = moment(clientDeadline).add(9, 'month');

        // skip weekends and holidays
        let isValidDate = false;
        while (!isValidDate) {
          isValidDate = true;

          // check if it's weekend (0 = Sunday, 6 = Saturday)
          if (nineMonthsDate.day() === 0 || nineMonthsDate.day() === 6) {
            nineMonthsDate.add(1, 'day');
            isValidDate = false;
            continue;
          }

          // check if it's a holiday
          if (annualCalendar?.modifiers) {
            if (holidays.some(holiday => moment(holiday).isSame(nineMonthsDate, 'day'))) {
              nineMonthsDate.add(1, 'day');
              isValidDate = false;
            }
          }
        }

        // TODO: remove this when 2026 annual calendar is configured.
        if (nineMonthsDate.year() === 2026) {
          nineMonthsMeetingOutlookEventId = null;
        } else {
          const eventTitle = "Rendez-vous de 9 mois avec " + data[i].clientName;
          const eventDetails = composeEventForOutlook({
            type: "newClientMeeting",
            title: eventTitle,
            date: nineMonthsDate,
            timezone: "Europe/Brussels",
            clientName: data[i].clientName,
            selectedColor: 'orange',
            attendees: []
          });

          const eventResponse = await createEvent(
            tokenResponse.accessToken,
            eventDetails
          );

          // save event to Maxime's planner
          saveCollaboratorsPlanner(
            null,
            navCommunity.id,
            'management',
            eventTitle,
            'remote',
            226, // Maxime's collaborator ID
            [String(226)],
            data[i].clientId,
            null,
            'A faire',
            nineMonthsDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSS"),
            null,
            'orange',
            null,
            null,
            60,
            0,
            null,
            nineMonthsDate.year(),
            token,
            eventResponse.id,
            eventResponse?.onlineMeeting?.joinUrl || null,
            [],
            null
          );

          nineMonthsMeetingOutlookEventId = eventResponse.id;
        }
      }

      // save to DB
      if (oneMonthMeetingOutlookEventId || nineMonthsMeetingOutlookEventId) {
        saveNewClients({
          token,
          organizationId: navCommunity.id,
          items: [{
            id: data[i].id,
            clientId: data[i].clientId,
            comments: data[i].comments,
            oneMonthMeeting: {
              ...data[i].oneMonthMeeting,
              outlookEventId: oneMonthMeetingOutlookEventId
            },
            nineMonthsMeeting: {
              ...data[i].nineMonthsMeeting,
              outlookEventId: nineMonthsMeetingOutlookEventId
            }
          }]
        });
      }
    }
  }

  const renderSelectedColumns = () => {
    return bindedSubTabsColumns[selectedSubTab.key];
  }

  const dateColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return '--';

    if (!rowData[args.field]) return '--';

    return rowData[args.field].date ?? rowData[args.field];
  }

  const monthColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span>#</span>);

    if (!rowData.deadline) return (<span>-</span>);

    const month = moment(rowData.deadline).month() + 1;

    return (<span>{month}</span>);
  }

  const clientNameColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span className="total-title">Total</span>);

    const clientName = rowData.clientName
    const clientGroup = rowData.clientGroup;
    const managerBU = rowData.managerBU;;
    const clientErpId = rowData.clientErpId;
    const horusSearchKey = rowData.horusSearchKey;

    if (!clientName) return (
      <div className="client-name-cell">
        <div className="client-name-cell-data">
          <span className="client-name-text">
            ID : {clientErpId}
          </span>
          <div className="client-name-info">
            {clientGroup} - {managerBU}
          </div>
          <div className="client-name-ids">
            <p>ERP ID : {clientErpId}</p>
            <p>Horus Key : {horusSearchKey}</p>
          </div>
        </div>
      </div>
    );

    return (
      <div className="client-name-cell">
        <div className="client-name-cell-data">
          <span className="client-name-text">{clientName}</span>
          <div className="client-name-info">
            {clientGroup} - {managerBU}
          </div>
          <div className="client-name-ids">
            <p>ERP ID : {clientErpId}</p>
            {/* <p>Horus Key : {horusSearchKey}</p> */}
          </div>
        </div>
        <div className="client-name-icons">
          <Link
            to={`/${language}/fiche-client/${rowData.clientId}`}
          >
            <Tooltip placement="topRight" title="Consulter la fiche client">
              <ClipBoardIcon
                size={18}
                className="icon"
                fill="#29394D"
              />
            </Tooltip>
          </Link>
        </div>
      </div>
    )
  }

  const statusColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span>--</span>);

    const active =
    rowData.departDates &&
    (rowData.departDates.depart_invoice ||
      rowData.departDates.depart_time_sheet ||
      rowData.departDates.communicated_departure)
      ? true
      : false;

    const statusBudgetHoraire = rowData.statusBudgetHoraire ?? "GLOBAL_BUDGET_NOT_AFFECTED";

    return (
      <div className="status-cell">
        <Tag className="status_tag">
          {_(rowData.status)}
        </Tag>
        {statusBudgetHoraire && (
          statusBudgetHoraire === "BUDGET_COMPLETED" ? (
            <div className="tag tag_success">
              <CheckIcon fill="#02AF8E" /> {_("completedBudgetization")}
            </div>
          ) : (
            <div
              className="pie_frame"
              style={
                active ? { marginTop: "40px", marginBottom: "-20px" } : {}
              }
            >
              {active === false && (
                <>
                  <div
                    className="pie"
                    style={{
                      "--p": 100,
                      "--c": "rgba(109, 127, 146, 0.3)",
                      position: "relative",
                      top: 50,
                    }}
                  />
                  <div
                    className="pie"
                    style={{
                      "--p": rowData.budgetPourcentage,
                    }}
                  >
                    {`${rowData.budgetPourcentage}%`}
                  </div>
                </>
              )}
              <div className="tag tag_danger">
                {statusBudgetHoraire === "UNAUTHORIZED_BUDGET" && (
                  <AlertTriangleIcon />
                )}
                {_(statusBudgetHoraire)}
              </div>
            </div>
          )
        )}
      </div>
    )
  }

  const managerColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) return (<span>--</span>);

    if (!rowData.managerName) return (<span>--</span>);

    return (
      <div>
        <Tooltip title={rowData.managerName}>
          {rowData.managerName}
        </Tooltip>
      </div>
    )
  }

  const rdvColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    if (rowData.rdv && rowData.id != selectedRow?.id) {
      const [year, month, day] = rowData.rdv.split("-");
      const date = new Date(year, month - 1, day);

      return (
        <div className="cell-input-field rdv-input-field">
          <Input
            className="input"
            value={moment(date, "YYYY-MM-DD").format("DD/MM")}
            name={args.field}
            disabled={true}
          />
          <span className="edit-icon">
            <IconPencil
              size={12}
              fill="#707f92"
              onClick={() => {
                setSelectedRow(rowData);
              }}
            />
          </span>
        </div>
      );
    }

    let date = null
    const keys = args.field.split('.');
    const hasValue = keys.reduce((obj, key) => obj && obj[key], rowData) &&
    keys.reduce((obj, key) => obj && obj[key], rowData) !== 'x';

    if (hasValue) {
      const [year, month, day] = rowData.rdv.split("-");
      date = new Date(year, month - 1, day);
    }

    return (
      <DatePicker
        value={!hasValue ? null : moment(date, "DD/MM")}
        placeholder="Selectionner"
        onChange={(date) => {
          const year = date._d.getFullYear();
          const month = date._d.getMonth() + 1;
          const day = date._d.getDate();
          handleRowModification(rowData, 'rdv', `${year}-${month}-${day}`);
        }}
        format={"DD/MM"}
        picker="day"
        className="cell-datepicker-input"
      />
    )
  }

  const switchColumnsBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    let classes = 'cell-switch-input';
    const keys = args.field.split('.');
    const isChecked = keys.reduce((obj, key) => obj && obj[key], rowData) === true || keys.reduce((obj, key) => obj && obj[key], rowData) === 'x';

    if (isChecked) {
      classes += ' cell-switch-input-checked';
    }

    return (
      <Switch
        size="small"
        checked={isChecked}
        className={classes}
        onChange={(checked) => {
          handleRowModification(rowData, args.field, checked);
        }}
      />
    )
  }

  const inputFieldColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);
    const fieldValue = rowData[args.field]

    return (
      <div className="cell-input-field">
        <Input
          className="input"
          value={fieldValue}
          name={args.field}
          onChange={(e) => {
            handleRowModification(rowData, args.field, e.target.value);
          }}
        />
      </div>
    )
  }

  const canalColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return '--';
    const value = rowData.canal;

    return (
      <CreatableSelect
        closeMenuOnSelect
        placeholder="Sélect."
        options={canalsOptions}
        value={canalsOptions.find(it => it.value === value) ||
          (value ? { value: value, label: value } : null)}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            fontSize: '12px',
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: '30px',
            padding: '0 6px',
          }),
          input: (provided) => ({
            ...provided,
            margin: '0px',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px',
          }),
          option: (provided) => ({
            ...provided,
            fontSize: '12px',
            padding: '6px 10px',
          }),
        }}
        onChange={(newValue) =>
          handleRowModification(rowData, args.field, newValue?.value || null)
        }
        onCreateOption={(inputValue) => {
          const newValue = { value: inputValue, label: inputValue };
          handleRowModification(rowData, args.field, inputValue);
        }}
        // isClearable
        isSearchable
      />
    );
  }

  const checkUncheckColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) {
      switch(args.field) {
        case "orderSent": return (<span>{rowData.orderSent}</span>);
        case "orderSigned": return (<span>{rowData.orderSigned}</span>);
        case "governance": return (<span>{rowData.governance}</span>);
        case "lmProposition": return (<span>{rowData.lmProposition}</span>);
        default: return (<span>--</span>);
      }
    }

    if (rowData[args.field]) {
      return <div className="centered-cell">
        <CheckIcon width="20" height="12" fill="#15B392" />
      </div>
    } else {
      return <div className="centered-cell">
        <IconClose size="11" fill="#C7253E" />
      </div>
    }
  }

  const amountColumnBodyTemplate = (rowData, args) => {
    if (['feeYearN', 'feeYearN1'].includes(args.field)) {
      return (<div>{formatAmount(rowData[args.field], true)}</div>);
    }
    return (<div>{formatAmount(rowData[args.field])}</div>);
  }

  const textColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) {
      return (<span>--</span>);
    }

    if (lodash.isEmpty(rowData[args.field])) {
      return (<span>--</span>);
    }

    return (<div>{rowData[args.field]}</div>);
  }

  const volumetryProgressionColumnBodyTemplate = (rowData) => {
    if (rowData.id === 0) {
      return <span>--</span>;
    }
    const budgetedPurchases = rowData.budgetedPurchases;
    const budgetedSales = rowData.budgetedSales;
    const budgetedFinancialTransactions = rowData.budgetedFinancialTransactions;
    const realPurchases = rowData.realPurchases;
    const realSales = rowData.realSales;
    const realFinancialTransactions = rowData.realFinancialTransactions;

    return (
      <div className="cell-volumetry">
        <div className="volumetry-grid">
          <div className="volumetry-header">
            <div className="volumetry-label"></div>
            <div className="volumetry-value">Budg</div>
            <div className="volumetry-value">Réal</div>
          </div>

          <div className="volumetry-row">
            <div className="volumetry-label">Achats</div>
            <div className="volumetry-value">
              <Input
                className="volumetry-input"
                value={lodash.isEmpty(budgetedPurchases) === false ? parseInt(budgetedPurchases) : null}
                name="budgetedPurchases"
                disabled
                onChange={(e) => {
                  if (!lodash.isNaN(e.target.value)) {
                    handleRowModification(rowData, 'budgetedPurchases', e.target.value);
                  }
                }}
              />
            </div>
            <div className="volumetry-value">
              {realPurchases != null ? parseInt(realPurchases) : '-'}
            </div>
          </div>

          <div className="volumetry-row">
            <div className="volumetry-label">Ventes</div>
            <div className="volumetry-value">
              <Input
                className="volumetry-input"
                value={lodash.isEmpty(budgetedSales) === false ? parseInt(budgetedSales) : null}
                name="budgetedSales"
                disabled
                onChange={(e) => {
                  if (!lodash.isNaN(e.target.value)) {
                    handleRowModification(rowData, 'budgetedSales', e.target.value);
                  }
                }}
              />
            </div>
            <div className="volumetry-value">
              {realSales != null ? parseInt(realSales) : '-'}
            </div>
          </div>

          <div className="volumetry-row">
            <div className="volumetry-label">Financiers</div>
            <div className="volumetry-value">
              <Input
                className="volumetry-input"
                value={lodash.isEmpty(budgetedFinancialTransactions) === false ? parseInt(budgetedFinancialTransactions) : null}
                name="budgetedFinancialTransactions"
                disabled
                onChange={(e) => {
                  if (!lodash.isNaN(e.target.value)) {
                    handleRowModification(rowData, 'budgetedFinancialTransactions', e.target.value);
                  }
                }}
              />
            </div>
            <div className="volumetry-value">
              {realFinancialTransactions != null ? parseInt(realFinancialTransactions) : '-'}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const actionsColumnBodyTemplate = (rowData, args) => {
    if (rowData.id === 0) return (<span>--</span>);

    const oneMonth = rowData?.oneMonthMeeting ? rowData.oneMonthMeeting : null;
    const nineMonths = rowData?.nineMonthsMeeting ? rowData.nineMonthsMeeting : null;

    return (
      <div className="edit-texts-icons">
        <Tooltip title="1 mois remarques">
          <span
            className="display-info-button"
            onClick={() => handleShowTextModal(true, rowData, MODAL_TEXT_1_MONTH_TYPE)}
            style={{
              backgroundColor: oneMonth?.isDone === 1 ? "#E3F9F5" : "#FFFFFF",
              borderColor: oneMonth?.isDone === 1 ? "#02AF8E" : "#3C4E64"
            }}
          >
            <CalendarWithTextIcon
              size={22}
              text="M+1"
              stroke={oneMonth?.isDone === 1 ? "#02AF8E" : "#3C4E64"}
              fill={oneMonth?.isDone === 1 ? "#E3F9F5" : "#FFFFFF"}
            />
          </span>
        </Tooltip>

        <Tooltip title="9 mois remarques">
          <span
            className="display-info-button"
            onClick={() => handleShowTextModal(true, rowData, MODAL_TEXT_9_MONTHS_TYPE)}
            style={{
              backgroundColor: nineMonths?.isDone === 1 ? "#E3F9F5" : "#FFFFFF",
              borderColor: nineMonths?.isDone === 1 ? "#02AF8E" : "#3C4E64"
            }}
          >
            <CalendarWithTextIcon
              size={22}
              text="M+9"
              stroke={nineMonths?.isDone === 1 ? "#02AF8E" : "#3C4E64"}
              fill={nineMonths?.isDone === 1 ? "#E3F9F5" : "#FFFFFF"}
            />
          </span>
        </Tooltip>

        <Tooltip title="Commentaires">
          <span
            className="display-info-button"
            // style={{ position: 'relative', display: 'inline-block' }}
            onClick={() => handleShowTextModal(true, rowData, MODAL_TEXT_COMMENT_TYPE)}
            style={{
              backgroundColor: rowData.comments && rowData.comments.trim() !== '' ? "#E3F9F5" : "#FFFFFF",
              borderColor: rowData.comments && rowData.comments.trim() !== '' ? "#02AF8E" : "#3C4E64"
            }}
          >
            <IconPencil
              size={15}
              fill={rowData.comments && rowData.comments.trim() !== '' ? "#02AF8E" : "#3C4E64"}
            />
          </span>
        </Tooltip>
      </div>
    );
  }

  const handleShowTextModal = (isVisible, rowData, type = MODAL_TEXT_COMMENT_TYPE) => {
    if (rowData) {
      setSelectedRow(rowData);
    } else {
      setSelectedRow(null);
    }
    setSelectedTextType(type);
    setShowTextModal(isVisible);
  }

  const handleRowModification = (rowData, modifiedPropertyName, modifiedPropertyValue) => {
    const keys = modifiedPropertyName.split('.');
    const updatedRowData = {
      ...rowData,
      [modifiedPropertyName]: modifiedPropertyValue
    };

    // Set the new value in the cloned rowData
    setValue({ ...rowData }, keys, modifiedPropertyValue);

    // Update the modifiedRows state

    setModifiedRows(prevState => {
      // Check if the row already exists in modifiedRows
      const modifiedRowIndex = prevState.findIndex(i => i.id === rowData.id);

      if (modifiedRowIndex > -1) {
        // Update existing modified row
        const updatedModifiedRows = [...prevState];
        updatedModifiedRows[modifiedRowIndex] = { ...updatedModifiedRows[modifiedRowIndex], ...updatedRowData };
        return updatedModifiedRows;
      } else {
        // Add new modified row
        return [...prevState, updatedRowData];
      }
    });

    // Update the displayedData state
    setDisplayedData(prevState =>
      prevState.map(i =>
        i.id === rowData.id ? { ...rowData, [modifiedPropertyName]: modifiedPropertyValue } : i
      )
    );
  }

  const setValue = (obj, keys, value) => {
    keys.reduce((accumulator, key, index) => {
      // If we're at the last key, set the value
      if (index === keys.length - 1) {
        accumulator[key] = value;
      } else {
        // If the key doesn't exist, create an empty object
        if (!accumulator[key]) {
          accumulator[key] = {};
        }
        return accumulator[key]; // Move to the next nested object
      }
      return accumulator;
    }, obj);
  };

  const handleSaveModifiedRows = () => {
    setIsSaving(prevState => ({...prevState, rowData: true}));

    saveNewClients({token, organizationId: navCommunity.id, items: modifiedRows}).then((res) => {
      if (res.status === 200) {
        setModifiedRows([]);
        setSelectedRow(null);
        toast.success("Les données ont été enregistrées avec succès");
        getNewClientsQuery.refetch();
        getNewClientsCanalsQuery.refetch();
      } else {
        toast.error("Une erreur est survenue lors de l'enregistrement des données");
      }
    }).catch(e => {
      toast.error("Une erreur est survenue lors de l'enregistrement des données");
      console.error("Error saving data : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, rowData: false}));
    });
  }

  const handleSaveComment = () => {
    let {
      id,
      clientId,
      comments,
      oneMonthMeeting,
      nineMonthsMeeting
    } = selectedRow;

    if (oneMonthMeeting?.isDone) {
      oneMonthMeeting = {
        ...oneMonthMeeting,
        isDone: oneMonthMeeting.isDone ? 1 : 0
      };
    }

    if (nineMonthsMeeting?.isDone) {
      nineMonthsMeeting = {
        ...nineMonthsMeeting,
        isDone: nineMonthsMeeting.isDone ? 1 : 0
      };
    }

    setIsSaving(prevState => ({...prevState, comment: true}));
    saveNewClients({
      token,
      organizationId: navCommunity.id,
      items: [{
        id,
        clientId,
        comments,
        oneMonthMeeting,
        nineMonthsMeeting
      }]
    }).then((res) => {
      if (res.status === 200) {
        setSelectedRow(null);
        toast.success("Commentaire enregistré avec succès.");
        getNewClientsQuery.refetch();
      } else {
        toast.error("Échec de l'enregistrement du commentaire. Veuillez réessayer.");
      }
    }).catch(e => {
      toast.error("Échec de l'enregistrement du commentaire. Veuillez réessayer.");
      console.error("Error saving comment : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, comment: false}));
    });
  }

  const handleExportNewClients = () => {
    if (!isExportingNewClients) {
      setIsExportingNewClients(true);
      exportNewClients({ token, organizationId: navCommunity.id, filters })
        .catch((e) => {
          toast.error("Une erreur est survenue lors de l'export");
          console.error("Error exporting new clients", { e });
        })
        .finally(() => setIsExportingNewClients(false));
    }
  };

  useEffect(() => {
    setCurrentPage(0);
    setPageStart(0);
  }, [filters.pageSize]);

  useEffect(() => {
    changeSelectedYear(filters.year);
  }, [filters.year]);

  return (
    <div className="clients-in-container">
       <div className="datatable-header">
        <div className="datatable-header-row">
          <div className="filters" style={{display: "flex", gap: "8px"}}>
            <CroissanceFilters
              filterFormIsVisible={false}
              filter={filters}
              additionalFilters={additionalFilters}
              nbResult={totalDataCount}
              updateFilter={setFilters}
              fetching={getNewClientsQuery.isFetching}
              collaborator={collaborator}
              preferences={preferences}
              exportButton={
                <div className="export_btn" onClick={handleExportNewClients}>
                  {!isExportingNewClients ? (
                    <IconExport size={16} />
                  ) : (
                    <LoadingIcon size={16} color="#3498db" />
                  )}
                  Exporter
                </div>
              }
            />
          </div>
        </div>
        <div className="datatable-header-row">
          <p className="data-count">
            Nombre de dossiers: <span>{totalDataCount}</span>
          </p>
          <div className="display-info-buttons">
            {SUB_TABS.map((tab) => (
              <button
                key={tab.key}
                className={`display-info-button ${selectedSubTab.key === tab.key ? 'active' : ''}`}
                onClick={() => setSelectedSubTab(tab)}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <DataTable
        value={displayedData}
        frozenValue={totalsData}
        lazy
        paginator
        totalRecords={totalDataCount}
        first={currentPage * filters.pageSize + 1}
        rows={filters.pageSize}
        onPage={(e) => {
          setCurrentPage(e.page);
          setPageStart(e.page * filters.pageSize);
        }}
        scrollable
        tableClassName="clients-in-datatable"
        loading={isLoadingData}
        loadingIcon={
          <div className="ripple_loading" style={{alignItems: 'center'}}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
          </div>
        }
      >
        {
          renderSelectedColumns().map(col => (
            <Column
              className="datatable-column"
              key={col.field}
              field={col.field}
              header={col.header}
              style={{width: col.style?.width ?? 'auto'}}
              sortable={col.sortable ?? false}
              body={col.body ?? null}
              alignHeader={col?.alignHeader ?? 'left'}
              resizeable={col?.resizeable ?? false}
              align={col?.align ?? 'center'}
            />
          ))
        }
      </DataTable>

      {/* save/cancel buttons */}
      {modifiedRows.length > 0 && (
        <div className="action-buttons">
          <Button
            label="Annuler"
            severity="secondary"
            size="small"
            onClick={() => {
              setModifiedRows([]);
              setDisplayedData(lodash.cloneDeep(data));
            }}
            disabled={isSaving.rowData}
          />
          <Button
            size="small"
            label={
              isSaving.rowData ? (
                <AnimatedLoadingIcon color="#ffffff" />
              ) : 'Enregistrer'
            }
            disabled={isSaving.rowData}
            severity="success"
            onClick={handleSaveModifiedRows}
          />
        </div>
      )}

      {/* comments modal dialog */}
      {showTextModal && selectedRow && (
        <Dialog
          visible={showTextModal && selectedRow}
          onHide={() => handleShowTextModal(false)}
          className="text-modal-dialog"
          header={
            selectedTextType === MODAL_TEXT_COMMENT_TYPE ? "Commentaire" :
            selectedTextType === MODAL_TEXT_1_MONTH_TYPE ? "1 mois remarques" :
            selectedTextType === MODAL_TEXT_9_MONTHS_TYPE ? "9 mois remarques" :
            "Commentaire"
          }
          footer={
            <div>
              <Button
                size="small"
                severity="success"
                onClick={handleSaveComment}
                disabled={isSaving.comment}
              >
                {
                  isSaving.comment ? (
                    <AnimatedLoadingIcon color="#ffffff" />
                  ):
                  'Enregistrer'
                }
              </Button>
            </div>
          }
        >
          {
            selectedTextType !== MODAL_TEXT_COMMENT_TYPE && (
              <div className="modal-check-stars">
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input
                    type="checkbox"
                    checked={
                      selectedTextType === MODAL_TEXT_1_MONTH_TYPE
                        ? selectedRow?.oneMonthMeeting?.isDone ?? false
                        : selectedRow?.nineMonthsMeeting?.isDone ?? false
                    }
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      if (selectedTextType === MODAL_TEXT_1_MONTH_TYPE) {
                        setSelectedRow(prevState => ({
                          ...prevState,
                          oneMonthMeeting: {
                            ...prevState.oneMonthMeeting,
                            isDone: isChecked ? 1 : 0
                          }
                        }));
                      } else if (selectedTextType === MODAL_TEXT_9_MONTHS_TYPE) {
                        setSelectedRow(prevState => ({
                          ...prevState,
                          nineMonthsMeeting: {
                            ...prevState.nineMonthsMeeting,
                            isDone: isChecked ? 1 : 0
                          }
                        }));
                      }
                    }}
                  />
                  Appel / Rendez-vous
                </label>

                <div className="star-rating">
                  <span className="rating-label">Insatisfait</span>
                  <div className="stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <img
                        key={star}
                        src={
                          selectedTextType === MODAL_TEXT_1_MONTH_TYPE ?
                          star <= (selectedRow?.oneMonthMeeting?.rating || 0)
                          ? "/img/icon/star.svg"
                          : "/img/icon/light_star.svg" :
                          star <= (selectedRow?.nineMonthsMeeting?.rating || 0)
                          ? "/img/icon/star.svg"
                          : "/img/icon/light_star.svg"
                        }
                        alt={`Star ${star}`}
                        onClick={() => {
                          if (selectedTextType === MODAL_TEXT_1_MONTH_TYPE) {
                            setSelectedRow(prevState => ({
                              ...prevState,
                              oneMonthMeeting: {
                                ...prevState.oneMonthMeeting,
                                rating: star
                              }
                            }));
                          } else if (selectedTextType === MODAL_TEXT_9_MONTHS_TYPE) {
                            setSelectedRow(prevState => ({
                              ...prevState,
                              nineMonthsMeeting: {
                                ...prevState.nineMonthsMeeting,
                                rating: star
                              }
                            }));
                          }
                        }}
                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                      />
                    ))}
                  </div>
                  <span className="rating-label">Ravi</span>
                </div>
              </div>
            )
          }
          <span className="p-float-label" style={{marginTop: '20px'}}>
            <InputTextarea
              id="comments"
              className="textarea"
              rows={5}
              value={
                selectedTextType === MODAL_TEXT_COMMENT_TYPE ? selectedRow.comments :
                selectedTextType === MODAL_TEXT_1_MONTH_TYPE ? selectedRow?.oneMonthMeeting?.note :
                selectedTextType === MODAL_TEXT_9_MONTHS_TYPE ? selectedRow?.nineMonthsMeeting?.note :
                selectedRow.comments
              }
              disabled={isSaving.comment}
              onChange={(e) => {
                const value = e.target.value;
                if (selectedTextType === MODAL_TEXT_COMMENT_TYPE) {
                  setSelectedRow(prevState => ({...prevState, comments: value}));
                } else if (selectedTextType === MODAL_TEXT_1_MONTH_TYPE) {
                  setSelectedRow(prevState => ({
                    ...prevState,
                    oneMonthMeeting: {
                      ...prevState.oneMonthMeeting,
                      note: value
                    }
                  }));
                } else if (selectedTextType === MODAL_TEXT_9_MONTHS_TYPE) {
                  setSelectedRow(prevState => ({
                    ...prevState,
                    nineMonthsMeeting: {
                      ...prevState.nineMonthsMeeting,
                      note: value
                    }
                  }));
                }
              }}
            />
            <label htmlFor="comments">{
              selectedTextType === MODAL_TEXT_COMMENT_TYPE ? "Commentaire" :
              selectedTextType === MODAL_TEXT_1_MONTH_TYPE ? "1 mois remarques" :
              selectedTextType === MODAL_TEXT_9_MONTHS_TYPE ? "9 mois remarques" :
              "Commentaire"
            }</label>
          </span>
        </Dialog>
      )}
    </div>
  )
}
